import React from "react";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apolloClient";
import { GlobalStyles } from "./themes/GlobalStyles";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./themes/ThemeContext";
import { CssBaseline } from "@mui/material";
import AppRoutes from "./routes";
import { LoadingProvider } from "./contexts/LoadingContext";
import { SchemaProvider } from "./components/SchemaProvider/SchemaProvider";
import { RbacProvider } from "./hooks/RbacContext";
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const AppContent = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <BrowserRouter>
        <ThemeProvider>
          <CssBaseline />
          <AuthProvider>
            <RbacProvider>
              <LoadingProvider>
                <GlobalStyles />
                <ErrorBoundary>
                  <SchemaProvider>
                    <AppRoutes />
                  </SchemaProvider>
                </ErrorBoundary>
              </LoadingProvider>
            </RbacProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </LocalizationProvider>
  );
};

const App = () => {
  return (
    <ApolloProvider client={client}>
      <AppContent />
    </ApolloProvider>
  );
};

export default App;
